import { PageVisibleState, PageVisibleValueOrigin } from '../../types';
export const pageVisibleValue = (_config, data, globalConfig) => {
  const value = globalConfig.pageVisibleValueOrigin === PageVisibleValueOrigin.documentHidden ? !document.hidden || false : data.pageVisibleState === PageVisibleState.VISIBLE;
  return {
    'pageVisible:value': value
  };
};